"use client";

import React from 'react';
import { useSession } from '@/context/SessionContext';
import CreateNotePage from '@/pages/CreateNotePage';
import { Skeleton } from '@/components/ui/skeleton';

const CreateNoteWrapper: React.FC = () => {
  const { session, loading } = useSession();

  if (loading) {
    return (
      <div className="p-4 md:p-6 space-y-6">
        <Skeleton className="h-40 w-full" />
        <Skeleton className="h-60 w-full" />
      </div>
    );
  }

  return <CreateNotePage session={session} />;
};

export default CreateNoteWrapper;